import { AnimatePresence, motion } from 'framer-motion';
import { Info } from 'lucide-react';

import { Alert, AlertDescription, Button } from '@design-system';

import { useShopInsuranceContext } from '@/features/shop-insurance';

export function GapFillBanner() {
  const { isGapFillMode, setGapFillMode } = useShopInsuranceContext();

  return (
    <AnimatePresence>
      {isGapFillMode && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
          className="overflow-hidden"
        >
          <Alert variant="success" className="items-center">
            <Info className="size-4 translate-y-0!" />
            <AlertDescription className="flex items-center justify-between">
              <span>Showing premiums to maximize coverage</span>
              <Button
                variant="outline"
                size="sm"
                className="h-7 px-2 text-xs"
                onClick={() => setGapFillMode(false)}
              >
                Exit
              </Button>
            </AlertDescription>
          </Alert>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
